export default {"theme":{"themes":{"light":{"primary":"#0078dc","accent":"#607C9C","secondary":"#607C9C","info":"#7B4C1F","warning":"#BC3131","error":"#BC3131","success":"#2FBC7B"}},"options":{"customProperties":true}}}
